export default "__VITE_ASSET__CnY7J67A__"